import { useState } from "react";
import Modal from "react-modal";
import * as S from "./styles";
import Remind from "assets/Header/remind.svg";
import Bot from "assets/Header/bot.svg";

import Notification from "../../Notifications";
import { useNotifications } from "contexts/notificationContext";
import { WorkNotification } from "interfaces/Notification";

const customStyles: ReactModal.Styles = {
  overlay: {
    top: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    backgroundColor: "rgba(25, 25, 25, 0.75)",
    overflow: "hidden",
    zIndex: "9999",
  },
  content: {
    border: "none",
    marginLeft: "auto",
    marginTop: "2rem",
    display: "flex",
    background: "var(--black-200)",
    width: "28rem",
    maxWidth: "28rem",
    maxHeight: "90vh",
    alignItems: "center",
    flexDirection: "column",
    padding: "0",
    left: "auto",
    bottom: "auto",
  },
};

export default function NotificationModal() {
  const [modalIsOpen, setIsOpen] = useState(false);

  const { notifications, hasUnseenNotification, seeAllNotifications } =
    useNotifications();

  function openModal() {
    setIsOpen(true);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }
  function closeModal() {
    setIsOpen(false);
  }
  return (
    <S.Container>
      <S.RemindButton>
        {hasUnseenNotification() && <S.Dot />}
        <img src={Remind} onClick={openModal} alt="Notificação" />
      </S.RemindButton>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        style={customStyles}
      >
        <S.HeaderContainer>
          <h2>Notificações</h2>

          <button onClick={() => seeAllNotifications()}>
            Marcar todas como vistas
          </button>
        </S.HeaderContainer>

        {notifications.length === 0 && (
          <S.BodyContainer>
            <img src={Bot} alt="Robo" />
            <S.Text>Está tudo calmo...</S.Text>
            <p>Não há notificações agora</p>
          </S.BodyContainer>
        )}

        {notifications.length !== 0 &&
          notifications.map((notification, index) => (
            <Notification key={index} notification={notification} />
          ))}
      </Modal>
    </S.Container>
  );
}
